module.exports = __webpack_public_path__ + "static/techcrunch_logo_shadowed-d647b7df03df7c690ebfe22f919d472e.png";